import { isOAuthError } from '@okta/okta-auth-js';
import type { OktaAuth, TransactionManagerInterface } from '@okta/okta-auth-js';

export const clearOktaTransaction = (oktaAuth: {
  transactionManager: Pick<TransactionManagerInterface, 'clear'>;
}): void => {
  oktaAuth.transactionManager.clear({
    clearSharedStorage: true,
    clearIdxResponse: true,
  });
};

export const isAuthorizeRejection = (search: string): boolean =>
  new URLSearchParams(search).has('error');

export interface OktaErrorDiagnostics {
  errorName: string;
  errorMessage: string;
  hasCodeParam: boolean;
  hasStateParam: boolean;
  hasInteractionCode: boolean;
  hasErrorParam: boolean;
  transactionExists: boolean;
  errorCode?: string;
  errorSummary?: string;
}

export const buildOktaErrorDiagnostics = (
  error: unknown,
  oktaAuth: OktaAuth,
  search: string
): OktaErrorDiagnostics => {
  const params = new URLSearchParams(search);

  let transactionExists = false;

  try {
    transactionExists = oktaAuth.transactionManager.exists();
  } catch {
    transactionExists = false;
  }

  const errorCode =
    params.get('error') ?? (isOAuthError(error) ? error.errorCode : undefined);
  const errorSummary = isOAuthError(error) ? error.errorSummary : undefined;

  return {
    errorName: error instanceof Error ? error.name : 'UnknownError',
    errorMessage: error instanceof Error ? error.message : String(error),
    hasCodeParam: params.has('code'),
    hasStateParam: params.has('state'),
    hasInteractionCode: params.has('interaction_code'),
    hasErrorParam: params.has('error'),
    transactionExists,
    ...(errorCode !== undefined && { errorCode }),
    ...(errorSummary !== undefined && { errorSummary }),
  };
};
